/* eslint-disable no-console */
import getTranslation from "next-translate/getT";
import type { Translate } from "next-translate";
// eslint-disable-next-line global-require
const i18nConfig = require("../../../i18n");

const { defaultLocale, locales } = i18nConfig as {
  defaultLocale: string;
  locales: string[];
};

export default async function getT(namespace: string | string[]): Promise<Translate> {
  try {
    if (typeof window === "undefined") {
      return getTranslation(defaultLocale, namespace);
    }

    const path = window.location.pathname.split("/")[1];
    const locale = locales.includes(path) ? path : defaultLocale;

    return getTranslation(locale, namespace);
  } catch (error) {
    console.error("Translation loading error:", error);

    return getTranslation(defaultLocale, namespace);
  }
}
